const API_URL = process.env.REACT_APP_API_URL;

// Resolves on success; rejects with an Error whose message is safe to show
// (the API's own text for rate limits, otherwise empty so a generic one is used).
export async function sendContact(data) {
  const response = await fetch(`${API_URL}/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = new Error(
      response.status === 429 && typeof body.detail === "string" ? body.detail : ""
    );
    error.status = response.status;
    throw error;
  }
}
